import { render, staticRenderFns } from "./CustomChip.vue?vue&type=template&id=5595671b&scoped=true"
import script from "./CustomChip.vue?vue&type=script&lang=js"
export * from "./CustomChip.vue?vue&type=script&lang=js"
import style0 from "./CustomChip.vue?vue&type=style&index=0&id=5595671b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5595671b",
  null
  
)

export default component.exports